import Icon from '@mdi/react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { WhiteBlock } from 'components/Layout'
import { Font14, BodyPrimary, Font16, Font32 } from 'components/Typography'
import { StyledIcon, Title } from 'features/home/components/HomeStatus/styles'
import CommonLinkButton from 'components/Button/CommonLinkButton'
import theme from 'theme_'
import {
  DesktopHeaderTitle,
  HomeStatusSuccessBoxIcon,
  Header,
  LeftBlock,
} from '../../HomeStatus/MainInfo/styles'
import { Savant } from 'components/Icons'

export const DeviceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`

export const HomeDeviceTitle = styled(Title)``

export const BackToAllDevicesLinkContainer = styled(Link)`
  display: flex;
  flex-direction: row;
  text-decoration: none;
  align-items: center;
  margin-bottom: ${theme.spacing.s};
  @media ${theme.devices.desktop} {
    margin-bottom: ${theme.spacing.sm};
  }
`

export const StyledHeader = styled(Header)`
  flex-direction: column-reverse;
  align-items: end;
  @media ${theme.devices.tablet} {
    flex-direction: row;
  }
`

export const StyledLeftBlock = styled(LeftBlock)`
  width: 100%;
  align-items: flex-start;
  @media ${theme.devices.tablet} {
    width: unset;
  }
`

export const BackToAllDevicesTitle = styled.div`
  ${Font14};
  font-weight: bold;
  color: ${theme.colors.otterWarmBlack};
`

export const BackArrowIcon = styled(Icon)`
  color: ${theme.colors.otterWarmBlack};
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 12px;
  flex-shrink: 0;
`

export const CardInformation = styled(WhiteBlock)<{
  bgColor?: string
  order?: number
}>`
  min-width: 220px;
  flex: 1;
  gap: ${theme.spacing.sm};
  ${({ bgColor }) => bgColor && `background-color: ${bgColor}`};
  @media ${theme.devices.tablet} {
    ${({ order }) => order && `order: ${order}`}
  }
  @media ${theme.devices.desktop} {
    order: unset;
  }
`

export const DeviceIcon = styled(Icon)``

export const CardInformationRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const CardInformationTitle = styled.span`
  color: ${theme.colors.duneWarmGrey};
  ${Font16};
  font-weight: 700;
`

export const CardInformationValue = styled.div<{ color?: string }>`
  color: ${({ color }) => color || theme.colors.duneWarmGrey};
  ${Font32};
  font-weight: bold;
`

export const DeviceInfoPropertyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const StyledPropertyValue = styled.div<{ bold?: boolean }>`
  ${({ bold }) => (bold ? 'font-weight: bold;' : '')}
`

export const HomeUIDCopy = styled.div`
  background: ${theme.colors.lighterGrey};
  border-radius: 8px;
  padding: 8px 16px 4px 16px;
  min-width: 240px;
  width: max-content;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const HomeUIDIcon = styled(StyledIcon)``

export const HomeUIDButton = styled(CommonLinkButton)`
  padding: 0;
`

export const StyledLabel = styled(BodyPrimary)`
  margin-bottom: 8px;
  font-size: 14px;
`

export const PropertyTitle = styled.span`
  color: ${theme.colors.moreGrey};
  font-weight: 325;
  font-size: 14px;
`

export const StyledCard = styled.div`
  padding: 16px 24px 24px;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 8px;
`

export const DeviceHeader = styled(DesktopHeaderTitle)<{ bold?: boolean }>`
  margin-left: 0;
  ${({ bold }) => (bold ? 'font-weight: bold' : '')};
  display: block;
`

export const MainCardBody = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  @media ${theme.devices.tablet} {
    grid-template-columns: 1fr 1fr;
  }
  @media ${theme.devices.desktop} {
    grid-template-columns: repeat(4, 1fr);
  }
`

export const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const DeviceCardSeparator = styled.div`
  display: flex;
  flex: 1;
  min-width: 220px;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`

export const DeviceWhiteCardBody = styled(WhiteBlock)<{ order: number }>`
  flex: 1;
  display: flex;
  gap: 20px;
  @media ${theme.devices.tablet} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`

export const StyledCardIcon = styled(HomeStatusSuccessBoxIcon)`
  margin-right: 0;
  /**
  * @description needs to align icon to other elements, depends on a icon size
  * as svg has padding
  */
  margin-bottom: -10%;
  height: 64px;
  width: auto;
  @media ${theme.devices.tablet} {
    height: 48px;
  }
`

export const StyledIconWrapper = styled.div<{ hideOnDesktop?: boolean }>`
  display: flex;
  align-items: center;
  height: 100%;
  & > svg {
    height: 64px;
    @media ${theme.devices.tablet} {
      height: 48px;
    }
  }
  @media ${theme.devices.desktop} {
    ${({ hideOnDesktop }) => hideOnDesktop && 'display: none;'}
  }
`

export const DeviceCardFlexboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  @media ${theme.devices.tablet} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`

export const SavantIcon = styled(Savant)`
  min-width: 16px;
  transform: translateX(16px);

  @media ${theme.devices.tablet} {
    transform: translateX(24px);
  }
`
